/**
 * @generated SignedSource<<366f5e0f21b6343d64a0ad5103b2d327>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewingAccountId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "viewingaccountid",
        "variableName": "viewingAccountId"
      }
    ],
    "concreteType": "StatementPeriodsConnection",
    "kind": "LinkedField",
    "name": "getstatementperiods2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StatementPeriod",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statementTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statementRange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startTs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endTs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "siId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StatementSelectQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "StatementSelectQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b321a82d51140ad40c5a03c5e7607dc4",
    "id": null,
    "metadata": {},
    "name": "StatementSelectQuery",
    "operationKind": "query",
    "text": "query StatementSelectQuery(\n  $accountId: UUID\n  $viewingAccountId: UUID\n  $first: Int\n) {\n  getstatementperiods2(accountid: $accountId, viewingaccountid: $viewingAccountId, first: $first) {\n    totalCount\n    nodes {\n      statementTitle\n      statementRange\n      startTs\n      endTs\n      siId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "a199bfd8c1f1db4775c84de871e8926b";

module.exports = node;
